const defaultTextValues = {
  title: {
    en: 'Title example'
  },
  subtitle: {
    en: 'Subtitle example'
  },
  sectionVideoTitle: {
    en: 'Ux pro tips!'
  },
  videoParagraph: {
    en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In blandit erat neque, a imperdiet justo fermentum nec. Proin aliquam elementum ligula ac tristique.'
  },
  streamParagraph: {
    en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In blandit erat neque, a imperdiet justo fermentum nec. Proin aliquam elementum ligula ac tristique.'
  },
  paragraph: {
    en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In blandit erat neque, a imperdiet justo fermentum nec. Proin aliquam elementum ligula ac tristique.'
  },
  buttonPrimary: {
    en: 'Button'
  },
  buttonHeroPrimary: {
    en: 'Button'
  },
  buttonHeroPrimaryTop: {
    en: 'Get tickets'
  },
  buttonHeroSecondary: {
    en: 'Button'
  },
  buttonSecondary: {
    en: 'Button'
  },
  buttonHeroSecondaryTop: {
    en: 'Sign in'
  },
  description: {
    en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In blandit erat neque, a imperdiet justo fermentum nec. Proin aliquam elementum ligula ac tristique.'
  },
  ticketBuy: {
    en: 'Register'
  },
  signInTitle: {
    en: 'Sign In'
  },
  eventButton: {
    en: 'Visit event website'
  },
};

export default defaultTextValues;
